import React, { JSX } from 'react';
import Chip from 'components/atoms/Chip';
import { RemoveFilterType } from 'components/types/FilterTypes';
import { ClinicalTrialsFiltersType } from 'lib/clinical-trials/types';

type ClinicalTrialsSelectedFiltersProps = {
  selectedFilters: ClinicalTrialsFiltersType;
  removeFilter: RemoveFilterType;
  clearAllFilters: () => void;
};

const ClinicalTrialsSelectedFilters = (
  props: ClinicalTrialsSelectedFiltersProps
): JSX.Element | null => {
  const { selectedFilters, removeFilter, clearAllFilters } = props;
  const chips = (
    Object.entries(selectedFilters) as [
      keyof ClinicalTrialsFiltersType,
      string[],
    ][]
  ).flatMap(([category, values]) =>
    values.map(value => ({ category, value }))
  );

  if (!chips.length) return null;

  return (
    <div className="selected-filters-list clinical-trials-selected-filters">
      <div className="tag-list">
        <button
          type="button"
          className="filter-clear-btn track-search"
          onClick={clearAllFilters}
          aria-label="Clear all filters"
        >
          Clear all filters
        </button>
        {chips.map(({ category, value }) => (
          <Chip
            key={`${category}-${value}`}
            filterName={value}
            filterCategory={category}
            removeFilter={removeFilter}
            label={value}
          />
        ))}
      </div>
    </div>
  );
};

export default ClinicalTrialsSelectedFilters;
